import { render, staticRenderFns } from "./ExpulsionOrderListItem.vue?vue&type=template&id=1b051818&scoped=true&"
import script from "./ExpulsionOrderListItem.vue?vue&type=script&lang=ts&"
export * from "./ExpulsionOrderListItem.vue?vue&type=script&lang=ts&"
import style0 from "./ExpulsionOrderListItem.vue?vue&type=style&index=0&id=1b051818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b051818",
  null
  
)

export default component.exports